// @flow
import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { Button, CardActions } from '@mui/material';
import { formatToIndianSystem } from 'utils/formatToIndianSystem';

const card = ({ records, title, duration, variant, link }) => (
  <>
    <CardContent>
      <Typography variant="h6" gutterBottom color="#ffff">
        {title}
        {duration && <Chip label={duration} color={variant} style={{ float: 'right' }} />}
      </Typography>
      <Typography variant="h2" color="#ffff">
        {formatToIndianSystem(records)}
      </Typography>
    </CardContent>
    <CardActions
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '16px',
      }}
    >
      {link && (
        <Button
          sx={{
            marginLeft: 'auto',
          }}
          onClick={() => link && window.open(link, '_blank')}
          color={variant}
          variant="contained"
          size="small"
        >
          View Details
        </Button>
      )}
    </CardActions>
  </>
);

function serverStatus(data) {
  return (
    <Box>
      <Card
        sx={{
          backgroundColor: `${data?.variant}.dark`,
          '&:hover': {
            backgroundColor: `${data.variant}.light`,
          },
          color: `${data?.variant}.contrastText`,
        }}
      >
        {card(data)}
      </Card>
    </Box>
  );
}

export default serverStatus;
